import { FC, useEffect, useState } from 'react'
import Select from 'react-select'
import { Reception } from '../../API'
import { ReceptionService } from '../services/ReceptionService'
import './select.scss'

interface ReceptionSelectProps {
  defaultValue?: string | null
  onChange: Function
}
const ReceptionSelect: FC<ReceptionSelectProps> = ({ defaultValue, onChange }) => {
  const [options, setOptions] = useState()
  const [items, setItems] = useState<Reception[]>([])
  const [selectedOption, setSelectedOption] = useState(defaultValue)

  const handleChange = (value: any) => {
    setSelectedOption(value)
    onChange(items.find((itm: Reception) => itm.id === value.value))
  }

  const fetchOptions = async () => {
    const res: any = await ReceptionService.Instance.list()
    if (res.data) {
      setItems(res.data)
      setOptions(
        res.data?.flatMap((itm: Reception) => {
          return { value: itm.id, label: `${itm.name}` }
        }),
      )
    }
  }

  useEffect(() => {
    fetchOptions()
  }, []) // eslint-disable-line

  return <Select value={selectedOption} options={options} onChange={handleChange} className='tbn-select' />
}

export default ReceptionSelect
